import { Component, OnInit, Input } from '@angular/core';
import { Test, TestTopList, TestViewModel } from '../models/test.model';
import { DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-high-score',
    templateUrl: './high-score.component.html',
    styleUrls: ['./high-score.component.css'],
    imports: [MatIcon, DatePipe]
})
export class HighScoreComponent implements OnInit {

  @Input() Test: TestViewModel;
  @Input() Results: TestTopList;
  constructor() { }

  ngOnInit() {
     
  }

}
